export const fontSerif = '"Lora", serif'
export const fontSans = '"Open Sans", sans-serif'
